import React from 'react';
import { useTranslation } from 'react-i18next';

import { SelectLabel } from '@weezevent/nacre';

const SpamScoreCondition = ({ condition, handleCondition }) => {
    const { t } = useTranslation();

    const scoreOptions = [
        { text: `0 (${t('ticket.moderation.statusesTransitions.transition.steps.actions.spam_score.not_spam')})`, value: 0 },
        { text: `10 (${t('ticket.moderation.statusesTransitions.transition.steps.actions.spam_score.likely_spam')})`, value: 10 },
        { text: `1000 (${t('ticket.moderation.statusesTransitions.transition.steps.actions.spam_score.spam')})`, value: 1000 }
    ];

    return (
        <SelectLabel
            useNew
            value={condition.score}
            options={scoreOptions}
            onChange={value => handleCondition('score', value)}
            label={t('ticket.moderation.statusesTransitions.transition.steps.actions.setSpamScoreActionLabel')}
            placeholder={t('ticket.moderation.statusesTransitions.transition.steps.actions.setSpamScoreActionLabel')}
        />
    );
};

export default SpamScoreCondition;
